import { axios } from '@/plugins/axios'

export class Student {

    static dashboardData () {
        return axios.get('/student/dashboard')
    }

    // Placeholder para rotas onde os cards são atualizados um a um
    static lastWatchedLesson () {
        return axios.get('/student/dashboard?q=last-lesson')
    }

    static alertsSummary () {
        return axios.get('/student/dashboard?q=alerts')
    }

    static paymentSummary () {
        return axios.get('/student/dashboard?q=payment')
    }
}
